import { cn } from '@wellesley/ui'
import { Search } from 'lucide-react'

// TODO: should be added real functionality
export const SearchInput = () => {
  return (
    <div className="relative flex w-[400px] items-center">
      <div className="pointer-events-none absolute left-3 z-10 flex items-center">
        <Search className="h-4 w-4 text-slate-500" />
      </div>
      <input
        type="text"
        placeholder="Search"
        className={cn(
          'flex h-auto w-full',
          'rounded-[24px] bg-slate-100',
          'border-0 px-12 py-2 outline-none',
          'focus:outline-none focus:ring-0',
        )}
      />
    </div>
  )
}
